<mat-card class="mt-3 mb-5">
    <div *ngIf="dateRangeNotFound" class="mb-4">
        <fuse-alert appearance="outline" [showIcon]="true" type="error" @shake>
            {{
                userRole === ACCOUNT_ROLE.provider ?
                    'No se pudo encontrar un rango de fechas para tu cuenta, verificar que tengas al menos un contrato activo' :
                    'No se pudo encontrar un rango de fechas para este proveedor, verificar que el proveedor tenga al menos un contrato activo'
            }}
        </fuse-alert>
    </div>
    <mat-card-header class="mb-5 font-bold">
        Descarga tus reportes
    </mat-card-header>
    <mat-card-content>
        <div class="flex flex-col lg:flex-row justify-between">
            <mat-form-field>
                <mat-label>Año</mat-label>
                <mat-select [value]="selectedYear$ | async"
                            (selectionChange)="selectedYear$.next($event.value)">
                    <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="flex flex-col">
                <small class="mat-primary mb-2">
                    Reporte anual: <span class="text-primary font-bold">{{ selectedYear$?.value }}</span>
                </small>
                <button color="primary" mat-flat-button (click)="downloadAnnualReport()"
                        [disabled]="!selectedYear$ || disableDownloadAnnualButton">
                    Descargar
                </button>
            </div>
            <mat-form-field class="mt-3 sm:mt-0">
                <mat-label>Mes</mat-label>
                <mat-select [value]="selectedMonth$ | async"
                            (selectionChange)="selectedMonth$.next($event.value)">
                    <mat-option *ngFor="let month of months"
                                [value]="month.value">{{ month.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div>
                <div class="flex flex-col">
                    <small class="mat-primary mb-2">
                        Reporte mensual: <span class="text-primary font-bold">
                        {{ getMonthName($safeNavigationMigration(selectedMonth$?.value)) + ' ' + validateNotNullYear($safeNavigationMigration(selectedYear$?.value)) }}
                    </span>
                    </small>
                    <button color="primary" mat-flat-button (click)="downloadMonthlyReport()"
                            [disabled]="!selectedYear$ || !selectedMonth$ || disableDownloadMonthlyButton">
                        Descargar
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="reportAlert$ | async as alert" class="mt-4">
            <fuse-alert
                appearance="outline"
                [showIcon]="true"
                [type]="alert.type"
                [@shake]="alert.type === 'error' || alert.type === 'warning'"
                @slideInLeft>
                {{ alert.message }}
            </fuse-alert>
            <mat-progress-bar [ngClass]="progressBarColorClass" mode="determinate"
                              [value]="reportAlertTime$ | async"></mat-progress-bar>
        </div>
    </mat-card-content>
</mat-card>
